import React from "react";
import classNames from "classnames";

import { Props, Views } from "./types";
import { Search } from "./search";
import { Resources } from "./resources";
import { ResourceGroups } from "./resourceGroups";
import { ResourceTags } from "./resourceTags";
import styles from "./styles.scss";

const ResourceAllocationMenu = React.forwardRef(
  (
    {
      className,
      style,
      allocatedResources,
      maxHeight,
      openedViews = [],
      select,
      unSelect,
      everyone,
    }: Props,
    forwardedRef: React.ForwardedRef<HTMLDivElement>,
  ) => {
    const [search, setSearch] = React.useState("");
    const isViewOpen = (view: Views) => !!openedViews.find((v) => v === view);

    return (
      <div
        ref={forwardedRef}
        className={classNames(styles.resourceAllocationMenu, {
          [`${className}`]: !!className,
        })}
        style={style}
      >
        <div className={styles.search}>
          <Search search={search} setSearch={setSearch} />
        </div>
        {[
          (style: object | undefined) => (
            <Resources
              search={search}
              allocatedResources={allocatedResources}
              style={style}
              select={select}
              unSelect={unSelect}
              everyone={everyone}
              isOpen={isViewOpen("resources")}
            />
          ),
          (style: object | undefined) => (
            <ResourceGroups
              search={search}
              allocatedResources={allocatedResources}
              style={style}
              select={select}
              unSelect={unSelect}
              isOpen={isViewOpen("groups")}
            />
          ),
          (style: object | undefined) => (
            <ResourceTags
              search={search}
              allocatedResources={allocatedResources}
              style={style}
              select={select}
              unSelect={unSelect}
              isOpen={isViewOpen("resourceTags")}
            />
          ),
        ].map((menu, _, menus) =>
          menu(
            !!maxHeight
              ? {
                  display: "flex",
                  flexDirection: "column",
                  maxHeight: (maxHeight - 50) / menus.length,
                }
              : undefined,
          ),
        )}
      </div>
    );
  },
);

export { ResourceAllocationMenu };
